<div
  class="modal fade show"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="labelId"
  *ngIf="open"
  (click)="onBackdrop($event)"
  style="display:block; background: rgba(0,0,0,.5);"
>
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document" #dialog>
    <div class="modal-content" (keydown.escape)="close()">
      <div class="modal-header">
        <h5 class="modal-title" [id]="labelId">{{ title }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body" #modalBody (scroll)="onModalBodyScroll($event)">
        <!-- If a template is provided, render it; else render HTML string -->
        <ng-container *ngIf="contentTpl; else rawHtml">
          <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        </ng-container>
        <ng-template #rawHtml>
          <div [innerHTML]="contentHtml"></div>
        </ng-template>
      </div>
      <div class="modal-footer d-flex justify-content-between align-items-center">
        <small class="text-muted" *ngIf="!hasScrolledToEnd && requiresScroll">Please scroll to the end to agree.</small>
        <small class="text-success" *ngIf="hasScrolledToEnd"><i class="bi bi-check-circle-fill me-1"></i>You have read the document.</small>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">Close</button>
          <button type="button" class="btn btn-primary" [disabled]="!hasScrolledToEnd" (click)="onAgree()">I Agree</button>
        </div>
      </div>
    </div>
  </div>
</div>
